import React, { Suspense, useContext, memo } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import { AuthContext } from "./context/AuthContext";
import { useGetAdminStatusQuery } from "./services/admin/admin";
import ProtectedRoute from "./services/helpers/ProtectedRoute";
import CircularProgress from "@mui/material/CircularProgress";
import { routes, protectedRoutes } from "./routes";

import Header from "./components/app-template/Header";
import Footer from "./components/app-template/Footer";
import ErrorBoundary from "./components/ErrorBoundary";
import { reportErrorToBackend } from "./services/errorReporting";
import "./App.scss";
import HealthCheck from "./components/HealthCheck";
import AdminNavbar from "./components/admin/helpers/AdminNavbar";

function App() {
  // Handler to send error report to backend
  const handleError = (error, errorInfo, errorPayload) => {
    reportErrorToBackend(errorPayload);
  };
  return (
    <Router
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <ErrorBoundary onError={handleError}>
        <MainContent />
      </ErrorBoundary>
    </Router>
  );
}

// Split the main content into a separate component
function MainContent() {
  const location = useLocation();
  const { isAuthenticated } = useContext(AuthContext);
  const { data: adminStatus } = useGetAdminStatusQuery(undefined, {
    skip: !isAuthenticated,
  });

  return (
    <div className="app-container">
      {/* Conditionally render Header based on route */}
      {location.pathname !== "/selcom" && location.pathname !== "/health" && (
        <Header className="app-header" />
      )}
      {location.pathname !== "/selcom" &&
        location.pathname !== "/health" &&
        adminStatus?.isAdmin &&
        adminStatus?.admin_type_id && (
          <AdminNavbar className="app-admin-header" />
        )}
      <div className="app-body">
        <Suspense fallback={<CircularProgress />}>
          <Routes>
            {routes?.map((route, index) => (
              <Route key={index} path={route.path} element={route.element} />
            ))}
            {protectedRoutes?.map((route, index) => (
              <Route
                key={index}
                path={route.path}
                element={<ProtectedRoute>{route.element}</ProtectedRoute>}
              />
            ))}
            <Route path="/health" element={<HealthCheck />} />
            {/* Add a fallback route if needed */}
          </Routes>
        </Suspense>
      </div>
      {location.pathname !== "/health" && <Footer className="app-footer" />}
    </div>
  );
}

export default memo(App);
